import { SPAN_SCOPE } from './spanScope';

export const SPAN_SCOPE_METRICS_ATTRIBUTES = {
    [SPAN_SCOPE.REPORT_SCOPE]: ['reportId', 'dateRange', 'campaignFilter', 'filters', 'accountType', 'isHeavyAccount'],
    [SPAN_SCOPE.CHAT_AGENT_SCOPE]: ['eventType', 'triggerName', 'module', 'isFirstMessage'],
};
